import { InstallerParamList } from '../types';
import useColorScheme from '../hooks/useColorScheme';
import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { useAuth } from '../auth/Auth';
import InstallerScreen from '../screens/InstallerScreen';

export const Installer = createStackNavigator<InstallerParamList>();


export default function InstallerNavigator() {
  const colorScheme = useColorScheme();
  const {status} = useAuth()

  return (<Installer.Navigator>
            <Installer.Screen name="InstallerScreen" component={InstallerScreen} options={{ headerShown: false, headerTitle: 'Installer', headerStyle: {
    backgroundColor: '#0fa8e4ff'
  },
  headerTitleStyle: {
    color: 'white'
  }}}/>
        </Installer.Navigator>)
} 



